import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageFerney: React.FC = () => (
  <LocalSeoPage
    city="Ferney-Voltaire"
    slug="depannage-informatique-ferney-voltaire"
    metaTitle="Dépannage Informatique Ferney-Voltaire | SOS IT Services"
    metaDescription="Technicien informatique à Ferney-Voltaire. PC lent, virus, WiFi, Windows. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous lâche à Ferney-Voltaire ? Nous intervenons rapidement, à domicile ou à distance. PC lent, virus, connexion WiFi instable ou Windows bloqué — diagnostic gratuit, devis clair, solution rapide."
    postalCode="01210"
    nearbyTowns={[
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Prévessin-Moëns', link: '/depannage-informatique-prevessin-moens' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Thoiry' },
      { name: 'Cessy' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Prévessin-Moëns', href: '/depannage-informatique-prevessin-moens' },
      { label: 'Dépannage informatique à Divonne-les-Bains', href: '/depannage-informatique-divonne-les-bains' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique dans la région de Genève', href: '/depannage-informatique-region-geneve' },
    ]}
  />
);

export default DepannageFerney;
